export default "__VITE_ASSET__BMlLyP$j8YFMgEE5MoRYvw__"